// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../../google/protobuf/Timestamp";
import { name2num, num2name, } from "../../(UserDeviceAccessLog)/Type";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { default as Long, } from "../../../../runtime/Long";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
import { unpackFns, } from "../../../../runtime/wire/scalar";
export function getDefaultValue() {
    return {
        timestampServerFrom: undefined,
        timestampServerTo: undefined,
        typesIn: [],
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.timestampServerFrom !== undefined)
        result.timestampServerFrom = encodeJson_1(value.timestampServerFrom);
    if (value.timestampServerTo !== undefined)
        result.timestampServerTo = encodeJson_1(value.timestampServerTo);
    result.typesIn = value.typesIn.map(value => tsValueToJsonValueFns.enum(value));
    return result;
}
export function decodeJson(value) {
    var _a, _b;
    const result = getDefaultValue();
    if (value.timestampServerFrom !== undefined)
        result.timestampServerFrom = decodeJson_1(value.timestampServerFrom);
    if (value.timestampServerTo !== undefined)
        result.timestampServerTo = decodeJson_1(value.timestampServerTo);
    result.typesIn = (_b = (_a = value.typesIn) === null || _a === void 0 ? void 0 : _a.map((value) => jsonValueToTsValueFns.enum(value))) !== null && _b !== void 0 ? _b : [];
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.timestampServerFrom !== undefined) {
        const tsValue = value.timestampServerFrom;
        result.push([1, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.timestampServerTo !== undefined) {
        const tsValue = value.timestampServerTo;
        result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    for (const tsValue of value.typesIn) {
        result.push([3, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.timestampServerFrom = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.timestampServerTo = value;
    }
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 3).map(([, wireValue]) => wireValue);
        const value = Array.from(unpackFns.int32(wireValues)).map(num => num2name[num]);
        if (!value.length)
            break collection;
        result.typesIn = value;
    }
    return result;
}
